import React from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white px-6">
      {/* 404 Text */}
      <h1 className="text-8xl font-bold text-lime-400">404</h1>

      {/* Message */}
      <h2 className="mt-4 text-2xl md:text-3xl font-semibold">
        Oops! Page not found
      </h2>
      <p className="mt-2 text-gray-400 text-center max-w-md">
        The page you’re looking for doesn’t exist or has been moved.
      </p>

      {/* Button */}
      <Link
        to="/"
        className="mt-6 px-6 py-3 bg-lime-400 text-black uppercase font-medium rounded-md hover:bg-lime-500 transition"
      >
        Go Home
      </Link>

      {/* Decorative element */}
      <div className="mt-10 w-full max-w-sm">
        <svg
          className="w-full"
          viewBox="0 0 400 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="200" cy="100" r="80" stroke="#a3e635" strokeWidth="6" />
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            stroke="#a3e635"
            strokeWidth="1px"
            dy=".3em"
            fontSize="28"
          >
            Lost?
          </text>
        </svg>
      </div>
    </div>
  );
};

export default PageNotFound;
